import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import Api from "../../services/Api";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faHashtag, faTimes } from '@fortawesome/free-solid-svg-icons';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        departamento: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state.departamento;
        state[e.target.name] = e.target.value;
        this.setState({ departamento: state });
    };
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const id_departamento = document.getElementById('id_departamento').value;
        const nombre = document.getElementById('nombre').value;
        var errores = [];
        if (!nombre) { errores.push("error_nombre"); }
        if (!id_departamento) { errores.push("error_id_departamento"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        console.log(formData);
        Swal.showLoading();
        authAxios.post("departamentos_visitas/editar", formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                Swal.close();
                Swal.fire(
                    'Departamentos Visita!',
                    datosRespuesta.data.msj,
                    'success'
                )
                this.props.history.push("/MasterDepartamentosVisita");
            })
            .catch(console.log)
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("departamentos_visitas/ver/" + this.props.match.params.id)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, departamento: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { load, departamento } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>EDITAR DEPARTAMENTO VISITA</b>)}
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos} id="form">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="id_departamento">ID. Departamento</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="id_departamento" id="id_departamento" defaultValue={departamento.ID_DEPARTAMENTO}
                                                            className={((this.verificarError("error_id_departamento")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="ID. DEPARTAMENTO" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el ID. Departamento</small>
                                                </div>
                                                <div className="col-md-4">
                                                    <input type="hidden" name="id" value={this.props.match.params.id} />
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="nombre" id="nombre" defaultValue={departamento.NOMBRE}
                                                        className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="NOMBRE" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Editar Dpto. Visita</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterDepartamentosVisita"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;